import { Avatar, Tooltip } from 'antd';
import { QualitativeFactorsRELC } from '../enterprise-applications';

type FactorsRendererProps = {
  factors: QualitativeFactorsRELC;
}

/**
 * Default qualitative factors used in the application for risk assessment.
 * 
 * These factors (Reputation, Employees, Life Safety, Compliance) represent 
 * critical dimensions for evaluating cybersecurity risk impact. Each factor 
 * helps quantify potential business consequences of security incidents.
 * 
 * R - Reputation
 * E - Employees
 * L - Life Safety
 * C - Compliance
 */
export const DefaultFactors = {
  reputation: 'R',
  employees: 'E',
  lifeSafety: 'L',
  compliance: 'C',
}

const FactorsRenderer: React.FC<FactorsRendererProps> = ({
  factors,
}) => {
  const highlightedStyles = {
    backgroundColor: '#437EF7',
    color: '#FFFFFF',
    fontWeight: 'bold',
    fontSize: '10px',
  };

  const nonHighlightedStyles = {
    backgroundColor: '#EEEEEE',
    color: '#979797',
    fontWeight: 'normal',
    fontSize: '10px',
  };
  

  return (
    <>
      {(Object.keys(DefaultFactors) as Array<keyof typeof DefaultFactors>).map((factor) => {
        const shouldBeHighlighted = factors[factor as keyof typeof factors];
        return (
          <Avatar
            key={factor}
            style={
              shouldBeHighlighted ? highlightedStyles : nonHighlightedStyles
            }
          >
            {DefaultFactors[factor]}
          </Avatar>
        );
      })}
      {factors.count > 0 && (
        <Tooltip
          title={`+${factors.count} custom factors`}
        >
          <Avatar
            style={{
              ...highlightedStyles,
              fontWeight: 300,
            }}
          >
            +{factors.count}
          </Avatar>
        </Tooltip>
      )}
    </>
  );
};

export default FactorsRenderer;
